import F84Game from "../Game";
import GameConfig from "./data/GameConfig";

export default class SoundManager {
	game: F84Game;
	playedSounds: string[] = [];

	private _muted: boolean;
	private _volume: number;

	get muted(): boolean {
		return this._muted;
	}
	set muted(value: boolean) {
		this._muted = value;
	}

	get volume(): number {
		return this._volume;
	}
	set volume(value: number) {
		this._volume = value;
	}

	constructor(game: F84Game, volume: number) {
		this.game = game;
		this._muted = false;
		this._volume = volume;
	}

	public add(key: string, config?: Phaser.Types.Sound.SoundConfig): Phaser.Sound.BaseSound {
		// if (this._muted) return;
		const c = config ? config : { volume: this._muted ? 0 : this._volume };
		if (!c.volume) c.volume = this._muted ? 0 : this.volume;
		return this.game.sound.add(key, c);
	}

	public get(key: string): Phaser.Sound.BaseSound {
		return this.game.sound.get(key);
	}

	public getAll(key: string): Phaser.Sound.BaseSound[] {
		return this.game.sound.getAll(key);
	}

	public play(key: string, playOnce = false, config?: Phaser.Types.Sound.SoundConfig | Phaser.Types.Sound.SoundMarker): void {
		if ((playOnce && this.playedSounds.find((s) => s == key)) || this._muted) return;
		const c = config ? config : { volume: this._volume };
		this.game.sound.play(key, c);
		if (playOnce) this.playedSounds.push(key);
	}

	public playVO(key: string, playOnce = false, config?: Phaser.Types.Sound.SoundConfig | Phaser.Types.Sound.SoundMarker): void {
		if (this._muted) return;
		if (GameConfig.get("enableVoiceOver")) {
			this.play(key, playOnce, config);
		}
	}

	public stop(key: string): void {
		this.game.sound.stopByKey(key);
	}
}
